import type { IpAddress } from "~domain/devices/models/common-device-model.ts";
import type {
  PilotDataFrameId,
  PilotDataFrameTypeClassId,
  PilotDataFrameTypeId,
} from "~domain/devices/models/pilot/pilot-data-frame-model.ts";
import type { PilotHwId } from "~domain/devices/models/pilot/pilot-model.ts";

import { z } from "zod";

export const backofficeFindPilotDataInfosResponseSchema = z
  .object({
    arrivalDate: z.coerce.date(),
    frame: z.string(),
    id: z.number().transform((s) => s as PilotDataFrameId),
    idHwMombox: z.number().transform((s) => s as PilotHwId),
    momboxDate: z.coerce.date(),
    momboxIp: z.string().transform((s) => s as IpAddress),
    type: z.object({
      id: z.number().transform((s) => s as PilotDataFrameTypeId),
      description: z.string(),
    }),
    typeClass: z.object({
      id: z.number().transform((s) => s as PilotDataFrameTypeClassId),
      description: z.string(),
    }),
  })
  .array();

export type BackofficeFindPilotDataInfosResponse = z.infer<typeof backofficeFindPilotDataInfosResponseSchema>;
